import template from './emittenten.html';
import controller from './emittenten.controller';
import './emittenten.scss';

let emittentenComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default emittentenComponent;



// WEBPACK FOOTER //
// ./client/app/common/forms/emittenten/emittenten.component.js